{
  "title": "Agregar cliente a un hogar",
  "relationship": "Relación",
  "relationshipTo": "Relación con el miembro principal {{whom}}",
  "alreadyMemberOf": "El cliente ya es miembro de",
  "thisHousehold": "este hogar",
  "anotherHousehold": "otro hogar",
  "memberSummary": "Resumen de miembros del hogar",
  "pleaseReview": "Revise su información para asegurarse de que sea correcta.",
  "name": "Nombre del cliente",
  "householdName": "Nombre del hogar",
  "addToHousehold": "Agregar al hogar",
  "added": "{{memberName}} ha sido agregado al hogar {{householdName}}",
  "failed": "Error al agregar un nuevo miembro.",
  "done": "Hecho",
  "save": "Guardar",
  "continue": "Continuar",
  "accessType": "Permisos",
  "householdUpdated": "El hogar ha sido actualizado para el cliente",
  "clientAddedToHousehold": "El cliente ha sido agregado al hogar",
  "alreadyMemberOfHousehold": "El cliente ya es miembro del hogar {{householdName}}",
  "back": "Atrás"
}
